<template>
<div class="chapter">
<div class="inner_page">
<div>
<div class="chapter" id="abb">
<p class="ctfm"><a href="#/eerbauckham0005#rabb">Abbreviations</a></p>
<div class="glossary">
<p class="glo"><span class="gt">AB</span> Anchor Bible</p>
<p class="glo"><span class="gt"><em>ABD</em></span> <em>Anchor Bible Dictionary</em></p>
<p class="glo"><span class="gt"><em>Adv. Haer.</em></span> <em>Adversus Haereses</em> (Irenaeus)</p>
<p class="glo"><span class="gt">AnBib</span> Analectia Biblica</p>
<p class="glo"><span class="gt"><em>Ant.</em></span> <em>Antiquities</em> (Josephus)</p>
<p class="glo"><span class="gt">ASNU</span> Acta Seminarii Neotestamentici Upsaliensis</p>
<p class="glo"><span class="gt">b.</span> Babylonian Talmud</p>
<p class="glo"><span class="gt"><em>BeO</em></span> <em>Bibbia e oriente</em></p>
<p class="glo"><span class="gt">BETL</span> Bibliotheca ephemeridum theologicarum lovaniensium</p>
<p class="glo"><span class="gt"><em>Bib</em></span> <em>Biblica</em></p>
<p class="glo"><span class="gt">BIS</span> Biblical Interpretation Series</p>
<p class="glo"><span class="gt"><em>BJRL</em></span> <em>Bulletin of the John Rylands Library</em></p>
<p class="glo"><span class="gt">BNTC</span> Black’s (Harper’s) New Testament Commentaries</p>
<p class="glo"><span class="gt"><em>BZ</em></span> <em>Biblische Zeitschrift</em></p>
<p class="glo"><span class="gt">BZNW</span> Beihefte zur Zeitschrift für die neutestamentliche Wissenschaft</p>
<p class="glo"><span class="gt"><em>C. Ap.</em></span> <em>Contra Apionem</em> (Josephus)</p>
<p class="glo"><span class="gt"><em>C. Cels.</em></span> <em>Contra Celsum</em> (Origen)</p>
<p class="glo"><span class="gt">CB[NT]</span> Coniectanea biblica: New Testament Series, Coniectanea neotestamentica</p>
<p class="glo"><span class="gt"><em>CBQ</em></span> <em>Catholic Biblical Quarterly</em></p>
<p class="glo"><span class="gt">CCSA</span> Corpus Christianorum Series Apocryphorum</p>
<p class="glo"><span class="gt">CG</span> Corpus Gnosticum (Nag Hammadi Library)</p>
<p class="glo"><span class="gt">CGTC</span> Cambridge Greek Testament Commentary</p>
<p class="glo"><span class="gt">CSCO</span> Corpus Scriptorum Christianorum Orientalium</p>
<p class="glo"><span class="gt"><em>De vir. ill.</em></span> <em>De viris illustribus</em> (Jerome)</p>
<p class="glo"><span class="gt">DJD</span> Discoveries in the Judean Desert</p>
<p class="glo"><span class="gt"><em>Ep.</em></span> <em>Epistulae</em> (Pliny, Seneca)</p>
<p class="glo"><span class="gt"><em>ETL</em></span> <em>Ephemerides theologicae lovanienses</em></p>
<p class="glo"><span class="gt"><em>ExpT</em></span> <em>Expository Times</em></p>
<p class="glo"><span class="gt">FRLANT</span> Forschungen zur Religion und Literatur des Alten und Neuen Testaments</p>
<p class="glo"><span class="gt">HDR</span> Harvard Dissertations in Religion</p>
<p class="glo"><span class="gt"><em>Hist. Conscr.</em></span> <em>Quomodo historia conscribenda sit</em> (Lucian of Samosata)</p>
<p class="glo"><span class="gt"><em>Hist. Eccl.</em></span> <em>Historia ecclesiastica</em> (Eusebius)</p>
<p class="glo"><span class="gt">HTKNT</span> Herders theologischer Kommentar zum Neuen Testament</p>
<p class="glo"><span class="gt"><em>HTR</em></span> <em>Harvard Theological Review</em></p>
<p class="glo"><span class="gt">ICC</span> International Critical Commentary</p>
<p class="glo"><span class="gt"><em>IEJ</em></span> <em>Israel Exploration Journal</em></p>
<p class="glo"><span class="gt"><em>Inst.</em></span> <em>Institutio oratoria</em> (Quintilian)</p>
<p class="glo"><span class="gt"><em>Int</em></span> <em>Interpretation</em></p>
<p class="glo"><span class="gt"><em>JBL</em></span> <em>Journal of Biblical Literature</em></p>
<p class="glo"><span class="gt"><em>JECS</em></span> <em>Journal of Early Christian Studies</em></p>
<p class="glo"><span class="gt"><em>JEH</em></span> <em>Journal of Ecclesiastical History</em></p>
<p class="glo"><span class="gt"><em>JHS</em></span> <em>Journal of Hellenic Studies</em></p>
<p class="glo"><span class="gt"><em>JJS</em></span> <em>Journal of Jewish Studies</em></p>
<p class="glo"><span class="gt"><em>JR</em></span> <em>Journal of Religion</em></p>
<p class="glo"><span class="gt"><em>JSHJ</em></span> <em>Journal for the Study of the Historical Jesus</em></p>
<p class="glo"><span class="gt"><em>JSJ</em></span> <em>Journal for the Study of Judaism in the Persian, Hellenistic, and Roman Periods</em></p>
<p class="glo"><span class="gt"><em>JSNT</em></span> <em>Journal for the Study of the New Testament</em></p>
<p class="glo"><span class="gt">JSNTSup</span> Journal for the Study of the New Testament Supplement Series</p>
<p class="glo"><span class="gt">JSOTSup</span> Journal for the Study of the Old Testament Supplement Series</p>
<p class="glo"><span class="gt"><em>JSS</em></span> <em>Journal of Semitic Studies</em></p>
<p class="glo"><span class="gt"><em>JTS</em></span> <em>Journal of Theological Studies</em></p>
<p class="glo"><span class="gt">m.</span> Mishnah</p>
<p class="glo"><span class="gt">NICNT</span> New International Commentary on the New Testament</p>
<p class="glo"><span class="gt">NIGTC</span> New International Greek Testament Commentary</p>
<p class="glo"><span class="gt"><em>NovT</em></span> <em>Novum Testamentum</em></p>
<p class="glo"><span class="gt">NovTSup</span> Novum Testamentum Supplements</p>
<p class="glo"><span class="gt">NRSV</span> New Revised Standard Version</p>
<p class="glo"><span class="gt"><em>NTS</em></span> <em>New Testament Studies</em></p>
<p class="glo"><span class="gt">Pap. Oxy.</span> Oxyrhynchus Papyri/us</p>
<p class="glo"><span class="gt"><em>PEQ</em></span> <em>Palestine Exploration Quarterly</em></p>
<p class="glo"><span class="gt"><em>RB</em></span> <em>Revue biblique</em></p>
<p class="glo"><span class="gt">SBLDS</span> Society of Biblical Literature Dissertation Series</p>
<p class="glo"><span class="gt">SC</span> Sources chrétiennes</p>
<p class="glo"><span class="gt">SNTSMS</span> Society for New Testament Studies Monograph Series</p>
<p class="glo"><span class="gt"><em>SPAW</em></span> Sitzungsberichte der Preußischen Akademie der Wissenschaften</p>
<p class="glo"><span class="gt"><em>ST</em></span> <em>Studia Theologica</em></p>
<p class="glo"><span class="gt">STAR</span> Studies in Theology and Religion</p>
<p class="glo"><span class="gt">TSAJ</span> Texte und Studien zum antiken Judentum</p>
<p class="glo"><span class="gt">TU</span> Texte und Untersuchungen</p>
<p class="glo"><span class="gt"><em>TynB</em></span> <em>Tyndale Bulletin</em></p>
<p class="glo"><span class="gt">WBC</span> Word Biblical Commentary</p>
<p class="glo"><span class="gt"><em>WTJ</em></span> <em>Westminster Theological Journal</em></p>
<p class="glo"><span class="gt">WUNT</span> Wissenschaftliche Untersuchungen zum Neuen Testament</p>
<p class="glo"><span class="gt">y.</span> Jerusalem Talmud</p>
<p class="glo"><span class="gt"><em>ZAC</em></span> <em>Zeitschrift für Antikes Christentum</em></p>
<p class="glo"><span class="gt"><em>ZNW</em></span> <em>Zeitschrift für die neutestamentliche Wissenschaft</em></p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eer-bauckham-0008.vue?0ffda4dc